import { CircularProgress } from "@mui/material";

// LOADING SPINNER
export default function LoadingSpinner() {
    return (
        <div style={{ padding: 50, display: 'flex', justifyContent: 'center' }}>
            <CircularProgress size={70} sx={{ color: 'var(--teal)' }} />
        </div>
    )
}
